import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from '../hooks';
import SearchContainer from '../components/Search/SearchContainer';
import NavContainer from '../components/Navigation/NavContainer';
import { Container } from '@mui/material';
import { selectAllPlayersList, getFront } from '../state/reducers/NewFrontReducer';
import SearchAutoComplete from '../components/Search/SearchAutoComplete';
import AdsenseAdd from '../components/AdsenseAdd';
import { PageContainer } from '../globals/styles';
import { RegisterPageView } from '../globals/Analytics';
const SearchScreen = () => {
    const dispatch = useAppDispatch();
    RegisterPageView({path:'/search'});
    useEffect(() => {
        dispatch(getFront());
    },[]);

    let allplayers = useAppSelector(selectAllPlayersList);

    return <PageContainer style={{marginBottom: '2rem'}}>
        <NavContainer />
        <div style={{paddingTop: '2rem'}}>
            <Container maxWidth="xl" style={{marginBottom: '2rem'}}>
                <SearchAutoComplete players={allplayers} /> 
                <AdsenseAdd />
            </Container>
        </div>
    </PageContainer>
}

export default SearchScreen;